// extracted by mini-css-extract-plugin
module.exports = {"chromeframe":"ProjectVideo_chromeframe__1lvvs","main":"ProjectVideo_main__1b9xd","frame":"ProjectVideo_frame__1FgCk","video":"ProjectVideo_video__1y0uf"};